module.exports = __webpack_public_path__ + "static/media/DSC_0029.1a1ba431.jpg";